import {CompetitionHistoryPageRouteMetaDataModel} from "./competition-history-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionHistoryPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.history,
      path: `history`,
      componentImport: () => import("../components/competition-history-page" /* webpackChunkName: "competition-history-page" */ ),
      metadataType: CompetitionHistoryPageRouteMetaDataModel
    });
  }
}